import { createSelector } from 'reselect';
const selectVideoPlayer = state => state.video_player;

export const selectVideo = createSelector(
  selectVideoPlayer,
  videoPlayer => videoPlayer.video
);
export const selectCurrentVideoId = createSelector(
  selectVideo,
  video => video.id
);
export const selectVideoViews = createSelector(
  selectVideo,
  video => video.views
);
export const selectVideoDuration = createSelector(
  selectVideoPlayer,
  videoPlayer => videoPlayer.duration
);
export const selectVideoReactions = createSelector(
  selectVideoPlayer,
  videoPlayer => videoPlayer.reactions
);
export const selectIsMainVideoOnSharePage = createSelector(
  selectVideoPlayer,
  videoPlayer => videoPlayer.isMainVideoOnSharePage
);
